import { ImageLifeQuiz, LetteratiQuiz } from '../models/QuizModel';
import { ViewModelBase } from './ViewModelBase';
import { GameManager } from '../managers/GameManager';
import { GenerateUniqueRandomIntegerArray } from '../tools/math/UniqueRandomIntegerArray';
import { GameType } from '../models/CBNGameModel';

export class LetteratiGameSceneModel extends ViewModelBase{

    private quiz:LetteratiQuiz;
    private gameManager:GameManager = (<GameManager>GameManager.instance);

    constructor(quiz:LetteratiQuiz){
        super();
        this.quiz = quiz;
    }

    update(timestep,dt){
        //
        this.updateTimer(timestep,dt);
    }

    //General Getters
    getCurrentScore():number{
        return this.quiz.currentScore;
    }
    getCurrentRoundNumber():number{
        return this.quiz.currentRound;
    }
    getMaxLife():number{
        return this.quiz.maxLife;
    }
    getCurrentLife():number{
        return this.quiz.currentLife;
    }
    getGameTimeRemaining():number{
        return this.quiz.currentGameTime;
    }
    getTimerProgress():number{
        let progress = this.quiz.currentTimeRemaining / this.quiz.getTimeLimit();
        return progress;
    }
    getTimeRemaining():number{
        return this.quiz.currentTimeRemaining + .5;
    }
    getTimeLimit():number{
        return this.quiz.getTimeLimit();
    }
    getGameTime():number{
        return this.quiz.getGameTime();
    }
    getIsPractice():boolean{
        return this.quiz.practiceMode;
    }
    private updateTimer(timestep,dt){
        
        if(this.quiz.practiceMode || this.isQuizDone()){
            return;
        }
        this.quiz.currentTimeRemaining -= dt / 1000;
        this.quiz.currentGameTime -= dt / 1000;

        if(this.quiz.currentTimeRemaining<=0){
            this.quiz.currentLife--;
            this.quiz.currentGivenAnswer = -1;
            this.emitter.emit('OnTimerEnd');
        }
        
        if(this.quiz.currentGameTime<=0)
        {
            this.quiz.currentLife--;
            this.quiz.currentGivenAnswer = -1;
            this.emitter.emit('OnTimerEnd');
        }

        this.emitter.emit('OnTimerChanged');
    }

    //Quiz Specific Getters
    getCurrentQuestion():string{
        try{
            return this.quiz.questions[this.quiz.currentQuestion].question;
        }catch(e){
            console.log(e.name + ': ' + e.message);
            return "";
        }
    }

    getQuestionMissingBlankProgressString():string{
        //replace characters in answers that's not in currentGivenLetters with #.
        let answer = this.quiz.questions[this.quiz.currentQuestion].answer;
        let result = (' ' + answer).slice(1);

        let re = new RegExp( "[^"+this.quiz.currentGivenLetters + `\\s']`,"gi");
        let letterChoicePool = result.replace(re,'#').toLowerCase(); //replace currentGivenLetters in result with #.
        return letterChoicePool;
    }

    getCurrentQuestionLetterChoiceStrings():Array<string>{
        return this.quiz.currentLetterChoices.map(letterChoice => letterChoice.letter);
    }

    getCurrentQuestionCorrectLetterChoice():Array<number>{
        let result:number[] = [];
        for (let index = 0; index < this.quiz.currentLetterChoices.length; index++) {
            const element = this.quiz.currentLetterChoices[index];
            if(element.correct){
                result.push(index);
            }
        }
        return result;
    }

    getCurrentAnswer():number{
        return this.quiz.currentGivenAnswer;
    }

    getCurrentQuestionAnswerString():string{
        return this.quiz.questions[this.quiz.currentQuestion].answer;
    }

    //Conditionals
    isCurrentChoiceCorrect():boolean{
        return this.getCurrentQuestionCorrectLetterChoice().find( ans => (ans) == this.getCurrentAnswer() ) == undefined ? false : true;
    }

    isQuizDone():boolean{
        let result;
        if(this.quiz.isDone || this.quiz.currentLife <= 0 || this.quiz.currentGameTime! <= 0){
            result = true;
        }else{
            result = false;
        }
        //console.log(`IsQuizDone: ${result}`);
        return result;
    }

    //Commands
    giveLetter(answer:number){
        this.quiz.currentGivenAnswer = answer;

        //let correctAnswers = this.getCurrentQuestionCorrectAnswers();
        let result:boolean = this.isCurrentChoiceCorrect();

        this.quiz.currentGivenLetters += this.quiz.currentLetterChoices[answer].letter.toLowerCase();
        if(result){
            this.quiz.currentCorrectAnswers++;
            let answer = this.quiz.questions[this.quiz.currentQuestion].answer;
            let answerCopy = (' ' + answer).slice(1); //Make a copy of answer
            answerCopy = answerCopy.replace(/[^a-zA-Z]+/g, ''); //Remove non-letter characters.
            let re = new RegExp(`[${this.quiz.currentGivenLetters}]`,"gi");
            let missingLetters = answerCopy.replace(re,'').toLowerCase(); //Remove currentGivenLetters from noDupeAnswer.
            if(missingLetters == ''){
                //Increment Score
                let scoreIncrement = this.quiz.fullScorePerQuestion * this.getTimerProgress();
                this.quiz.currentScore += scoreIncrement;
                this.quiz.currentScore = Math.floor(this.quiz.currentScore);
                this.emitter.emit('OnGiveAnswer');
            }
        }else{
            //Reduce Time on wrong Letter Choice
            this.quiz.currentTimeRemaining -= 5;
            this.quiz.currentTimeRemaining = Math.max(this.quiz.currentTimeRemaining,0);
            this.quiz.currentGameTime -= 5;
            this.quiz.currentGameTime = Math.max(this.quiz.currentGameTime,0.01);
            console.log(`Answer: ${this.getCurrentQuestionLetterChoiceStrings()[answer]} Time Reduced: -5s`);
            
        }

        this.emitter.emit('OnGiveLetter');
    }

    nextLetterQuestion(){
        this.generateLetterChoices();
    }

    private generateLetterChoices(){
        let answer = this.quiz.questions[this.quiz.currentQuestion].answer; //Get answer phrase.
        let answerCopy = (' ' + answer).slice(1); //Make a copy of answer
        
        //letterchoicepool = removeLettersInXFromY(removeDuplicateCharacters(answer) ,removeDuplicateCharacters(currentGivenLetters))
        let noDupeAnswer = Array.from(new Set(answerCopy.split(''))).join(""); //Remove Duplicate Chars
        noDupeAnswer = noDupeAnswer.replace(/[^a-zA-Z]+/g, ''); //Remove non-letter characters.
        let re = new RegExp(`[${this.quiz.currentGivenLetters}]`,"gi");
        let letterChoicePool = noDupeAnswer.replace(re,'').toLowerCase(); //Remove currentGivenLetters from noDupeAnswer.

        //Get 1-3 unique random from letterchoicepool put into currentchoices;
        let random =  Phaser.Math.Between(1,3);
        if(letterChoicePool.length < random){
            random = letterChoicePool.length;
        }
        let uniqueRandomArray:number[];
        this.quiz.currentLetterChoices = [];
        uniqueRandomArray = GenerateUniqueRandomIntegerArray(random,0,letterChoicePool.length);
        for (let index = 0; index < uniqueRandomArray.length; index++) {
            this.quiz.currentLetterChoices.push({letter:letterChoicePool[uniqueRandomArray[index]],correct:true});
        }
        //fill in currentChoices to 4 with letters not in currentgivenLetters and letterchoicepool
        //>Get character set not in currentGivenLetters and letterChoicePool
        let wrongCharacters:string[]= [];
        let alphabet = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
        alphabet.forEach(element => {
            if(this.quiz.currentGivenLetters.indexOf(element) < 0 && letterChoicePool.indexOf(element) < 0){
                wrongCharacters.push(element);
            }
        });
        while(wrongCharacters.length < 4 - this.quiz.currentLetterChoices.length){
            wrongCharacters.push(alphabet[Math.floor(Math.random()*(alphabet.length))]);
        }
        //>Get Unique Numbers for wrongCharactersSet
        uniqueRandomArray = GenerateUniqueRandomIntegerArray(4 - this.quiz.currentLetterChoices.length,0,wrongCharacters.length);
        //>Fill currentLetterChoices up to 4 of unique characters from wrongCharactersSet
        for (let index = 0; index < uniqueRandomArray.length; index++) {
            this.quiz.currentLetterChoices.push({letter:wrongCharacters[uniqueRandomArray[index]],correct:false});
        }
        //Shuffle currentChoices
        Phaser.Utils.Array.Shuffle(this.quiz.currentLetterChoices);
    }
    
    nextQuestion(){

        //Call Vendor's onGameLevelComplete Callback
        let cache = this.gameManager.buildConfig;

        // if(this.gameManager.cbnGameConfig!.gameType != GameType.full)
        // {
        //     this.emitter.emit('onEndQuiz');
        //     this.gameManager.cbnGameConfig!.onGameEnd(this.quiz.currentScore,cache.name);
        //     return;
        // }

        this.gameManager.cbnGameConfig!.onGameLevelComplete(this.quiz.currentScore,cache.name, this.gameManager.pracPlayOption);
        this.quiz.currentRound++;

        if(this.quiz.currentQuestion+1 >= this.quiz.questions.length){
            // this.quiz.isDone = true;
            this.quiz.currentQuestion = 0;
            this.quiz.questions
            //Shuffle currentChoices
            Phaser.Utils.Array.Shuffle(this.quiz.questions);
        }else{
            this.quiz.currentQuestion++;
        }

        if(this.isQuizDone() || this.gameManager.cbnGameConfig!.gameType != GameType.full){
            this.emitter.emit('OnQuizEnd');
            this.gameManager.cbnGameConfig!.onGameEnd(this.quiz.currentScore,cache.name, this.gameManager.pracPlayOption);
        }else{
            this.quiz.currentTimeRemaining = this.quiz.getTimeLimit();
            this.quiz.currentGivenLetters = '';
            this.generateLetterChoices();
            //Reset letters
            
        }        
    }

    //Handlers
    onAnswerButtonDown(){
        (<any>this).viewModel.giveLetter((<any>this).answer);
    }
}